import { submitPage, restoreButtonState, checkValidInputs } from './submit'
import { capitalize } from './utils/capitalize'

// TODO: gotta review some types in this file
const FIELD_TITLES = {
  fullName: 'Full Name',
  firstName: 'First Name',
  lastName: 'Last Name',
  emails: 'Email',
}

globalThis.RebillyCardMounted = false
globalThis.RebillyAchMounted = false
globalThis.RebillyApplePayMounted = false
globalThis.RebillyDigitalWalletMounted = false

let formSelectedPayment
let submitted
let updatedOrderSummary
let websiteId
let config
let enabledPayments

document.addEventListener('OrderSummaryUpdate', function (event) {
  updatedOrderSummary = (event as any).detail
  updateRebillyConfig()
})

globalThis.mountRebillyElement = function (paymentType) {
  const paymentRadioInputs = [...(document.querySelectorAll("[name='rebilly-payment-method']") as any)]
  const Rebilly = globalThis.Rebilly
  if (!Rebilly.initialized) return
  if (paymentType == 'payment-card' && globalThis.RebillyCardMounted != true) {
    globalThis.RebillyCard = Rebilly.card.mount('.payment-card-mount')
    globalThis.RebillyCard.on('change', function (event) {
      const field = document.querySelector('.payment-card-mount').closest('.pai-payment-field')
      const errorField = field.querySelector('.pai-payment-field-error-list')
      setCardErrors(event, errorField)
    })
    globalThis.RebillyCardMounted = true
  } else if (paymentType == 'ach' && globalThis.RebillyAchMounted != true) {
    globalThis.RebillyAchType = Rebilly.bban.mount('#bank-account-type', 'accountType')
    globalThis.RebillyAchNumber = Rebilly.bban.mount('#bank-account-number', 'accountNumber')
    globalThis.RebillyAchRouting = Rebilly.bban.mount('#bank-routing-number', 'routingNumber')
    globalThis.RebillyAchMounted = true
  } else if (paymentType == 'apple-pay') {
    if (globalThis.ApplePaySession || $('#rebilly-apple-pay-button').length) {
      if ($('#apple-pay-unavailable').length) $('#apple-pay-unavailable').remove()
    } else {
      const para = document.createElement('p')
      para.setAttribute('id', 'apple-pay-unavailable')
      para.style.textAlign = 'center'
      para.innerText = 'ApplePay is unavailable at this time.'
      if ($('#apple-pay-unavailable').length == 0) $('#apple-pay-mount').append(para)
    }
  }

  paymentRadioInputs.forEach((radioInput) => (radioInput.disabled = false))
}

globalThis.updatedRebillyPaymentMethod = function (clickedInputElement) {
  const rebillyElement = clickedInputElement.closest('.elPAI')
  const inputElements = rebillyElement.querySelectorAll("[name='rebilly-payment-method']")

  inputElements.forEach(function (inputElement) {
    const mountElement = rebillyElement.querySelector('.' + inputElement.value + '-mount')
    const contentElement = rebillyElement.querySelector('.' + inputElement.value + '-content')
    const parentField = inputElement.closest('.pai-payment-field')

    inputElement.checked ? parentField.classList.add('is-active') : parentField.classList.remove('is-active')
    contentElement.style.display = inputElement.checked ? 'block' : 'none'
    if (mountElement) mountElement.style.display = inputElement.checked ? 'block' : 'none'
  })
  formSelectedPayment = clickedInputElement.dataset.selectedPaymentMethod
  // Workfaround for syncing cfAR before submiting google pay
  globalThis.processForm()
}

function setCardErrors(event, errorField) {
  if (event.error) {
    errorField.classList.add('is-active')
    errorField.innerText = event.error.message
  } else if (event.valid) {
    errorField.classList.remove('is-active')
  }
}

globalThis.addEventListener('load', function () {
  if (!document.querySelector('.elPAI')) return
  const paymentRadioInputs = [...(document.querySelectorAll("[name='rebilly-payment-method']") as any)]
  paymentRadioInputs.forEach((radioInput) => (radioInput.disabled = true))
  enabledPayments = paymentRadioInputs.map((el) => el.getAttribute('value'))
  const Rebilly = globalThis.Rebilly

  const submitFormButton = document.querySelector('[href="#submit-form"]')
  if (submitFormButton) {
    document.querySelectorAll('.elPAI .pai-submit').forEach((element) => {
      element.remove()
    })
  }
  const rebillyKeys = document.getElementById('rebilly-keys')
  const publishableKey = rebillyKeys.getAttribute('data-rebilly-publishable-key')
  const organizationId = rebillyKeys.getAttribute('data-rebilly-organization-id')
  websiteId = rebillyKeys.getAttribute('data-rebilly-website-id')
  globalThis.RebillyConfig = {
    // TODO (Payment Gateway): we need to retrieve this from back-end and save it in the HTML
    publishableKey: publishableKey,
    organizationId: organizationId,
    kountAccountId: '700000', // This is for capturing kount fraud sessions
    websiteId: websiteId,
    transactionData: {
      currency: 'USD',
      amount: 1,
      label: 'Product Purchase',
    },
  }

  if (enabledPayments.includes('digital-wallet')) {
    globalThis.RebillyConfig.digitalWallet = {
      // TODO (Payment Gateway): This price has to be calculated based on the user cart
      transactionData: {
        amount: 1,
        currency: 'USD',
        countryCode: 'US',
        label: 'My Cool product',
      },
      allowedCardBrands: [
        Rebilly.digitalWallet.GooglePayAllowedCardNetworks.Mastercard,
        Rebilly.digitalWallet.GooglePayAllowedCardNetworks.Visa,
      ],
      // TODO (Payment Gateway): This merchant information has to be retrieved from DB
      merchantConfig: {
        merchantName: '3stec',
        merchantOrigin: 'mycf.myclickfunnels.test',
      },
      googlePayDisplayOptions: {
        buttonColor: 'white',
        buttonType: 'long',
      },
    }
  }

  document.querySelectorAll('#cfAR input[data-rebilly]').forEach(function (cfARInput) {
    const dataRebillyAttribute = cfARInput.getAttribute('data-rebilly')
    const dataCfFormField = cfARInput.getAttribute('data-cf-form-field')
    const pageInputField = document.querySelector('input' + '[name="' + dataCfFormField + '"]')
    if (!pageInputField) {
      cfARInput?.removeAttribute('data-rebilly')
    } else {
      pageInputField?.setAttribute('data-rebilly', dataRebillyAttribute)
    }
  })

  $('[name="rebilly-payment-method"]').on('click', function (evt: any) {
    const paymentType = evt.target.value
    if (!Rebilly.initialized) Rebilly.initialize(globalThis.RebillyConfig)
    if (paymentType == 'apple-pay') updateRebillyConfig()
    globalThis.unmountUnusedPaymentMethods()
    globalThis.mountRebillyElement(paymentType)
    globalThis.updatedRebillyPaymentMethod(evt.target)
  })

  const form = document.querySelector('#cfAR')

  Rebilly.initialize(globalThis.RebillyConfig)
  Rebilly.on('ready', function () {
    document.querySelectorAll('.elPAI').forEach(function (rebilly) {
      const radioInputButton = rebilly.querySelector('[name="rebilly-payment-method"]') as any
      radioInputButton.checked = true
      globalThis.updatedRebillyPaymentMethod(radioInputButton)
    })
    // Order here matters. It seems we need to first mount digitalWallet
    // in order to get the proper token on the "token-ready" rebilly event
    if (enabledPayments.includes('digital-wallet')) {
      globalThis.RebillyDigitalWallet = Rebilly.digitalWallet.mount('.digital-wallet-mount', {
        type: 'googlePay',
        form: form,
        extraData: {
          method: 'digital-wallet',
        },
      })
      globalThis.RebillyDigitalWalletMounted = true
    }
    const paymentType = $('[name="rebilly-payment-method"]:checked').val()
    globalThis.mountRebillyElement(paymentType)
  })

  // The token is ready, and we can submit the form
  // This listener is used for express payment methods like applePay, googlePay
  Rebilly.on('token-ready', (data) => {
    console.log('FramePay success', data)
    globalThis.parent.postMessage('success', '*')
    ;(form.querySelector('input[data-rebilly="token"]') as any).value = data.id
    clearErrors()
    globalThis.processForm()
    if (!checkValidInputs()) {
      restoreButtonState()
      submitted = false
      return
    }
    submitPage()
  })

  $(document).on('click', '.pai-submit', function () {
    if (!submitted) {
      submitted = true
      globalThis.unmountUnusedPaymentMethods()
      rebillyProcessOrder()
    }
  })
  // Workfaround for syncing cfAR before submiting google pay
  $(document).on('change', '.elInput', function () {
    globalThis.processForm()
  })
})

function clearErrors() {
  document.querySelectorAll('.pai-payment-field-error-list').forEach(function (error) {
    error.innerHTML = ''
  })
  document.querySelector('.pai-payment-global-errors-list').classList.remove('is-active')
  document.querySelectorAll('.pai-payment-field-error-list.cf-dynamic-input-error').forEach(function (error) {
    error.remove()
  })
}

globalThis.unmountUnusedPaymentMethods = function () {
  const paymentType = $('[name="rebilly-payment-method"]:checked').val()
  if (paymentType != 'payment-card' && globalThis.RebillyCardMounted == true) {
    globalThis.RebillyCard.unmount()
    globalThis.RebillyCardMounted = false
  }
  if (paymentType != 'apple-pay' && globalThis.RebillyApplePayMounted == true) {
    globalThis.RebillyApplePay.unmount()
    globalThis.RebillyApplePayMounted = false
  }
  if (paymentType != 'ach' && globalThis.RebillyAchMounted == true) {
    globalThis.RebillyAchType.unmount()
    globalThis.RebillyAchNumber.unmount()
    globalThis.RebillyAchRouting.unmount()
    globalThis.RebillyAchMounted = false
  }
}

function escapeHtml(unsafe) {
  return unsafe
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&quot;')
    .replace(/'/g, '&#039;')
    .replace(/\(|\)/g, '')
    .replace(/"/g, "'")
    .replace(/function/g, '')
    .replace(/__proto__/g, '')
    .replace(/prototype/g, '')
    .replace(/toString/g, '')
    .replace(/valueOf/g, '')
    .replace(/constructor/g, '')
    .replace(/script/g, '')
    .replace(/eval/g, '')
    .replace(/http/g, '')
    .replace(/"/g, "'")
    .replace(/supports/gi, '')
    .replace(/import/gi, '')
    .replace(/\{|\}/gi, '')
    .replace(/;/gi, '')
    .replace(/@import/gi, '')
    .replace(/expression/gi, '')
    .replace(/url/gi, '')
    .replace(/javascript/gi, '')
}

async function updateRebillyConfig() {
  const Rebilly = globalThis.Rebilly
  if (!(globalThis.ApplePaySession && enabledPayments.includes('apple-pay'))) return
  if (!Rebilly.initialized) Rebilly.initialize(config)
  if (!Rebilly._$controllerFrame$_) return

  const unescapedLabel = updatedOrderSummary.productVariants.map((el) => el.name).join(',')
  const label = escapeHtml(unescapedLabel)
  const currency = updatedOrderSummary.orderPreviewData.currency
  const amount = updatedOrderSummary.orderPreviewData.total
  config.transactionData = { currency, label, amount }

  try {
    await Rebilly.update(config)
  } catch (error) {
    console.log('Apple Pay error', error)
  }

  if (!globalThis.RebillyApplePay) {
    globalThis.RebillyApplePay = Rebilly.applePay.mount('#apple-pay-mount')
    globalThis.RebillyApplePayMounted = true
  }
}

function setTokenErrors(error) {
  clearErrors()
  if (error.code === 'api-validation') {
    error.invalidFields.forEach(function (fieldError) {
      document.querySelectorAll('#cfAR input[data-rebilly]').forEach(function (formInputField: any) {
        if (formInputField.type === 'hidden') return
        const rebillyFieldName = formInputField.getAttribute('data-rebilly')
        const regex = new RegExp(rebillyFieldName, 'i')
        if (regex.test(fieldError.field)) {
          const dataCfFormField = formInputField.getAttribute('data-cf-form-field')
          const pageInputField = document.querySelector(`input[name="${dataCfFormField}"]`) as any
          if (!pageInputField || pageInputField.type === 'hidden') return
          const errorMessage = capitalize(fieldError.message)

          $(pageInputField).parent().append(
            `<p class="pai-payment-field-error-list cf-dynamic-input-error is-active">
              ${errorMessage}
            </p>`
          )
        }
      })
    })
  } else if (error.details && error.details.length) {
    const rebillyPaymentGlobalErrorsList = document.querySelector('.pai-payment-global-errors-list')
    rebillyPaymentGlobalErrorsList.classList.add('is-active')
    let errorHTML = ''
    error.details.forEach((detail) => {
      if (typeof detail == 'object') {
        const fieldName = detail['rebilly-data'] || detail['data-rebilly']
        $(`[data-rebilly="${fieldName}"]`)
          .parent()
          .append(
            `<p class="pai-payment-field-error-list cf-dynamic-input-error is-active">
              ${FIELD_TITLES[fieldName] || capitalize(fieldName)} ${detail.error}
            </p>`
          )
      } else {
        errorHTML += `<p> ${detail} </p>`
      }
    })
    rebillyPaymentGlobalErrorsList.innerHTML = errorHTML
  } else if (error.message && error) {
    const rebillyPaymentGlobalErrorsList = document.querySelector('.pai-payment-global-errors-list')
    rebillyPaymentGlobalErrorsList.classList.add('is-active')
    rebillyPaymentGlobalErrorsList.innerHTML = error.message
  }
}

export const rebillyProcessOrder = (): void => {
  const Rebilly = globalThis.Rebilly
  const extraData = { method: formSelectedPayment }
  const form = document.querySelector('#cfAR')
  clearErrors()
  globalThis.processForm()
  if (!checkValidInputs()) {
    restoreButtonState()
    submitted = false
    return
  }
  Rebilly.createToken(form, extraData)
    .then(function (result) {
      console.log('Framepay success', result)
      globalThis.parent.postMessage('success', '*')
      submitPage()
    })
    .catch(function (error) {
      console.log('Framepay error', error)
      globalThis.parent.postMessage('error', '*')
      ;(form.querySelector('input[data-rebilly="token"]') as any).value = ''
      setTokenErrors(error)
      restoreButtonState()
      submitted = false
    })
}
